module.exports = __webpack_public_path__ + "img/left-2.0234c004.png";